module.exports = __webpack_public_path__ + "static/logo-hinge-ab6de9750634bf61bf6b58abace32a2c.png";